export default "/images/52f9a67ebb1a2f1ea8b27ebbe61343b6.avif";